
import "@/assets/css/tpay-btn.css"
import {defineComponent} from 'vue'


export default defineComponent({
  emits: ['btn:click']
})
